// utils/websocket.js
import store from '@/vuex/store'; // 引入 Vuex store
import Cookies from 'js-cookie';
class WebSocketUtil {
  constructor(url) {
    this.url = url; // WebSocket 服务器地址
    this.socket = null; // WebSocket 实例
    this.listeners = {}; // 事件监听器
    this.reconnectAttempts = 0; // 重连次数
    this.maxReconnectAttempts = 5; // 最大重连次数
    this.reconnectInterval = 3000; // 重连间隔时间（毫秒）
    this.heartbeatInterval = 1000; // 心跳包间隔时间（毫秒）
    this.heartbeatTimer = null; // 心跳包定时器
    this.isManualClose = false; // 是否手动关闭连接
  }

  // 连接 WebSocket
  connect(userId,token) {
    if (this.socket) {
      console.warn('WebSocket is already connected.');
      return;
    }

    this.isManualClose = false; // 重置手动关闭标志
    this.socket = new WebSocket(this.url + '/' + userId + '/' + token);
    // console.log(this.url,userId,token)
    this.socket.onopen = () => {
      console.log('WebSocket connection opened.');
      this.reconnectAttempts = 0; // 重置重连次数
      this.emit('open');
      this.startHeartbeat(); // 启动心跳包
    };

    this.socket.onmessage = (event) => {
      //console.log('WebSocket 接收消息:', event.data);
      //this.emit('message', event.data);
	  const data = JSON.parse(event.data)
	  this.onMessage(event.data);
    };

    this.socket.onclose = () => {
      console.log('WebSocket 连接关闭.');
      this.emit('close');
      this.stopHeartbeat(); // 停止心跳包
      this.socket = null;

      if (!this.isManualClose) {
        this.handleReconnect(userId,token); // 非手动关闭时尝试重连
      }
    };

    this.socket.onerror = (error) => {
      console.error('WebSocket error:', error);
      this.emit('error', error);
      this.handleReconnect(userId,token); // 发生错误时尝试重连
    };
  }

  // 发送消息
  send(message) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(message);
      //console.log('消息发送成功:', message);
    } else {
      console.warn('WebSocket 未连接.');
    }
  }

  // 关闭 WebSocket
  close() {
    this.isManualClose = true; // 标记为手动关闭
    if (this.socket) {
      this.socket.close();
      console.log('WebSocket 关闭成功.');
    } else {
      console.warn('WebSocket 未连接.');
    }
  }

  // 处理重连
  handleReconnect(userId,token) {
    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      this.reconnectAttempts++;
      console.log(`Attempting to reconnect (${this.reconnectAttempts}/${this.maxReconnectAttempts})...`);
      setTimeout(() => {
        this.connect(userId,token);
      }, this.reconnectInterval);
    } else {
      console.error('达到重新连接最大次数.');
    }
  }

  // 启动心跳包
  startHeartbeat() {
    this.heartbeatTimer = setInterval(() => {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.send(JSON.stringify({ type: 'heartbeat' })); // 发送心跳包
        //console.log('发送心跳.');
      }
    }, this.heartbeatInterval);
  }

  // 停止心跳包
  stopHeartbeat() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer);
      this.heartbeatTimer = null;
      console.log('心跳停止.');
    }
  }

  // 注册事件监听
  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
  }

  // 移除事件监听
  off(event, callback) {
    if (this.listeners[event]) {
      this.listeners[event] = this.listeners[event].filter(listener => listener !== callback);
    }
  }

  // 触发事件
  emit(event, ...args) {
    if (this.listeners[event]) {
      this.listeners[event].forEach(listener => listener(...args));
    }
  }
}

export default WebSocketUtil;


// WEBPACK FOOTER //
// ./src/utils/WebSocket.js